import { render, staticRenderFns } from "./CmsOsV2ConsentDialog.vue?vue&type=template&id=0f44dcb7&lang=pug&"
import script from "./CmsOsV2ConsentDialog.vue?vue&type=script&lang=js&"
export * from "./CmsOsV2ConsentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
